import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Popover, Searchbox } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { AiSearchPopoverPanel } from '../AiSearchPopoverPanel/AiSearchPopoverPanel';
import { FilterChip } from '../FilterChip/FilterChip';
import { useAutoOpenPopover } from '../useAutoOpenPopover';
export const GetAiFilterChipTID = (parentTestId)=>getTestIds(parentTestId);
export const useAiChipPopover = (autoOpen)=>{
    const [anchorEl, setAnchorEl] = useState(null);
    const anchorRef = useAutoOpenPopover(autoOpen, setAnchorEl);
    return {
        anchorEl,
        anchorRef,
        openAt: setAnchorEl,
        close: ()=>setAnchorEl(null)
    };
};
export const AiChipShell = (param)=>{
    let { testId, fieldLabel, biPrefix, autoOpen, operator, valuePrefix, valueLabel, valueSegments, combinator, tone, applyText, interactive = true, onOpen, onApply, onRemove, search, children } = param;
    const testIds = useMemo(()=>GetAiFilterChipTID(testId), [
        testId
    ]);
    const { anchorEl, anchorRef, openAt, close } = useAiChipPopover(autoOpen);
    const handleOpen = (event)=>{
        onOpen();
        openAt(event.currentTarget);
    };
    const handleApply = ()=>{
        if (onApply() !== false) close();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                inline: true,
                ref: anchorRef,
                children: /*#__PURE__*/ _jsx(FilterChip, {
                    testId: testId,
                    fieldLabel: fieldLabel,
                    operator: operator,
                    valuePrefix: valuePrefix,
                    valueLabel: valueLabel,
                    valueSegments: valueSegments,
                    combinator: combinator,
                    tone: tone,
                    onValueClick: interactive ? handleOpen : undefined,
                    onFieldClick: interactive ? handleOpen : undefined,
                    onRemove: ()=>onRemove(),
                    removeBiName: "".concat(biPrefix, "_remove")
                })
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: testIds.AiFilterChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: close,
                children: /*#__PURE__*/ _jsx(AiSearchPopoverPanel, {
                    testId: testId,
                    title: fieldLabel,
                    onClose: close,
                    applyText: applyText,
                    onApply: handleApply,
                    closeBiName: "".concat(biPrefix, "_close"),
                    applyBiName: "".concat(biPrefix, "_apply"),
                    pinnedTop: search != null ? /*#__PURE__*/ _jsx(Searchbox, {
                        testId: testIds.AiFilterChipTestIds.Search(),
                        bi: {
                            name: "".concat(biPrefix, "_search")
                        },
                        value: search.value,
                        debounceTime: 0,
                        fluidWidth: true,
                        onChange: (event)=>search.onChange(event.target.value),
                        onClear: ()=>search.onChange('')
                    }) : undefined,
                    children: typeof children === 'function' ? children({
                        apply: handleApply
                    }) : children
                })
            })
        ]
    });
};
